import { Ref, forwardRef, useState } from 'react';
import { Pressable, View } from 'react-native';
import { useAnalytics } from 'services/analytics/useAnalytics';
import { Platform } from 'utils/platform';

import FocusView from 'components/FocusView';
import { Icons } from 'components/Icons';
import { usePlayer } from 'components/Player/context';
import { useProgram } from 'components/Program/context';

type VideoPlayButtonProps = {
  black?: boolean;
};

const VideoPlayButton = forwardRef<View, VideoPlayButtonProps>(({ black }, ref?: Ref<View>) => {
  const { play } = usePlayer();
  const program = useProgram();
  const analytics = useAnalytics();
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const handleOnPress = () => {
    analytics.triggerMediaPlayActionEvent({
      programId: program.id,
      programTitle: program.title,
      programAgeRating: program.rating,
      programAdUnit: program.ads?.adunit?.val!,
      programCategory: program.category?.map((tag) => tag.name).join(', '),
      programProducer: program.ads?.adunit?.name,
      programDirector: program.director,
      programGenre: program.genre.map((genre) => genre.name).join(', '),
      programYear: program.year,
    });

    play();
  };

  return (
    <FocusView
      style={{
        borderWidth: 2,
        borderColor: !isFocused ? 'transparent' : 'red',
        borderRadius: 50,
      }}>
      <Pressable
        ref={ref}
        hasTVPreferredFocus
        style={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onFocus={() => (Platform.isAndroidTV ? setIsFocused(true) : {})}
        onBlur={() => (Platform.isAndroidTV ? setIsFocused(false) : {})}
        onPress={handleOnPress}>
        {!black ? (
          <Icons.SolidPlayCircular height="36" width="36" />
        ) : (
          <Icons.SolidPlay color="black" />
        )}
      </Pressable>
    </FocusView>
  );
});

export default VideoPlayButton;
